import { Tooltip } from 'react-tooltip';
import { OrderProductListItem } from '../interface/interface';
import { AlertIcon } from '../assets/svgImages';

interface ProductAlertProps {
  orderProduct: OrderProductListItem;
  index: number;
}

const ProductAlerts = (props: ProductAlertProps) => {
  const { orderProduct, index } = props;
  return (
    <div className="flex flex-col justify-center">
      <div className="flex items-center justify-start">
        {orderProduct.invalidReason ? (
          <>
            <a
              data-tooltip-id={`password-info-${index}`}
              data-tooltip-place="top-start"
            >
              <AlertIcon className="fill-secondary-pink-700 me-1" />
            </a>
            <Tooltip
              id={`password-info-${index}`}
              className="!bg-secondary-cornflowerblue-50 !text-primary-blue-500"
            >
              {orderProduct.invalidReason}
            </Tooltip>
          </>
        ) : (
          <></>
        )}
        {orderProduct?.product?.name}
      </div>
      {orderProduct.substituteProduct?.substituteFlag ? (
        <>
          <div
            data-tooltip-id={`substitute-info-${index}`}
            data-tooltip-place="top-start"
            className="px-2 py-1 mt-2 mx-auto ms-0 rounded-full inline-flex items-center justify-center 
            bg-blue text-pink-50 bg-secondary-pink-700 font-semibold text-sm"
          >
            <AlertIcon className="fill-pink-50 me-1" />
            Substituted
          </div>
          <p className="text-xs text-left italic mt-1.5">
            Substitute Product Consent Provided
          </p>
          <Tooltip
            id={`substitute-info-${index}`}
            className="!bg-secondary-cornflowerblue-50 !text-primary-blue-500 ms-2"
          >
            Substitute for:
            {orderProduct?.substituteProduct?.productPrescribed?.name}
          </Tooltip>
        </>
      ) : (
        <></>
      )}
      {orderProduct.containsAllowedProduct ? (
        <>
          <div
            data-tooltip-id={`substitute-info-${index}`}
            data-tooltip-place="top-start"
            className="px-2 py-1 mt-2 mx-auto ms-0 rounded-full inline-flex items-center justify-center 
            bg-blue text-pink-50 bg-secondary-pink-700 font-semibold text-sm"
          >
            <AlertIcon className="fill-pink-50 me-1" />
            Allowed Product
          </div>
          <p className="text-xs text-left italic mt-1.5">
            Contains Allowed Product
          </p>
          <Tooltip
            id={`substitute-info-${index}`}
            className="!bg-secondary-cornflowerblue-50 !text-primary-blue-500 ms-2"
          >
            Allowed product for:
            {orderProduct?.prescription?.productName}
          </Tooltip>
        </>
      ) : (
        <></>
      )}
      {orderProduct.product.isSASBProduct ? (
        <>
          <div
            data-tooltip-id={`sasb-info-${index}`}
            data-tooltip-place="top-start"
            className="px-2 py-1 mt-2 mx-auto ms-0 rounded-full inline-flex items-center justify-center 
            bg-blue text-pink-50 bg-secondary-pink-700 font-semibold text-sm"
          >
            <AlertIcon className="fill-pink-50 me-1" />
            SAS-B
          </div>
          <p className="text-xs text-left italic mt-1.5">
            Contains SAS-B Prescriber
          </p>
          <Tooltip
            id={`sasb-info-${index}`}
            className="!bg-secondary-cornflowerblue-50 !text-primary-blue-500 ms-2"
          >
            SAS-B Prescription for:
            {orderProduct?.prescription?.productName}
          </Tooltip>
        </>
      ) : (
        <></>
      )}
      {!orderProduct.product.requiresPrescription && (
        <div
          data-tooltip-id={`non-prescription-product-info-${index}`}
          data-tooltip-place="top-start"
          className="px-2 py-1 mt-2 mx-auto ms-0 rounded-full inline-flex items-center justify-center 
            bg-blue text-pink-50 bg-secondary-pink-700 font-semibold text-sm"
        >
          <AlertIcon className="fill-pink-50 me-1" />
          Non-Prescription Product
        </div>
      )}
    </div>
  );
};

export default ProductAlerts;
